<ng-template [ngIf]="isLoad" [ngIfElse]="loading">
  <ng-template [ngIf]="unlog" [ngIfElse]="log">
    <div class="col-12">
      <div class="row justify-content-center">
        <h2 class="col-10">Connectez vous pour continuer</h2>
        <div class="col-sm-4 col-10">
          <app-user-login-form></app-user-login-form>
        </div>

      </div>
    </div>
  </ng-template>


  <!-- spinner -->
  <div *ngIf="IsWait" class="col-12">
    <div class="row justify-content-center mt-4">
      <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
    </div>
  </div>






  <ng-template #log >
    <div class="row station-detail">
      <div class="col-sm-12">
        <div class="row justify-content-between card-planning" *ngIf="stationDetail">

          <h3 class="col-12 titleBookk bold">{{stationAvailabilities?.name}}</h3>
          <div class="col-sm-auto col-12 adressmar">
            <label class="col-12">
              <mat-icon aria-hidden="false" aria-label="Adresse">place</mat-icon>
              {{ 'SEARCH.STATIONCONFIRMEADRESSE' | translate }} : {{stationDetail?.street}} {{stationDetail?.city}}
            </label>
          </div>
          <div class="col-sm-auto col-12 adressmar">
            <label *ngIf="stationDetail?.type === 1 && stationDetail?.autonomy !== 0" class="col-12">
              <mat-icon aria-hidden="false" aria-label="Autonomie">ev_station</mat-icon>
              {{ 'SEARCH.STATIONCONFIRMEAUTONOMIE' | translate }} : {{stationDetail?.autonomy}}km
            </label>
            <label *ngIf="stationDetail?.type === 0 && stationDetail?.autonomy !== 0" class="col-12">
              <mat-icon aria-hidden="false" aria-label="Autonomie">ev_station</mat-icon>
              {{ 'SEARCH.STATIONDETAILPUISSANCE' | translate }} : {{stationDetail?.autonomy}}kW
            </label>
            <label *ngIf="stationDetail?.type === 7 && stationDetail?.autonomy !== 0" class="col-12">
              <mat-icon aria-hidden="false" aria-label="Autonomie">ev_station</mat-icon>
              {{ 'SEARCH.STATIONDETAILPUISSANCE' | translate }} : {{stationDetail?.autonomy}}kW
            </label>
          </div>

          <h4 class="col-12 titleBookk text-center bold mt-2">{{ 'SEARCH.STATIONCONFIRMEDISPONIBILITE' | translate }}</h4>


          <div class="col-12 card-planning">
            <div class="row planning">
              <table class="col-12">
                <thead>

                  <tr>
                    <th colspan="48" *ngFor="let day of dayCount;">{{day | date:"dd/MM/yy"}}</th>
                  <tr>
                  <tr>
                    <th class="hour" colspan="2" *ngFor="let hour of hourCount;"><label>{{hour}}</label></th>
                  </tr>
                  <tr>

                    <th class="hour" colspan="2" *ngFor="let hour of hourCount;">|</th>

                  </tr>

                </thead>
                <tbody>
                  <tr>
                    <td class="content-resa"> </td>

                    <td class="content-resa" *ngFor="let availabilitie of availabilities;" [ngClass]="availabilitie">
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          
          <div *ngIf="IsWait === false" class="col-12 card my-3 promo">
            <div class="row mt-3 mb-2">
              <h4 class="col-5 col-md-4 text-md-right ">{{ 'SEARCH.STATIONCONFIRMECODEPROMO' | translate }} :</h4>
              <div class="col-7 col-md-4">
                <input type="text" class="form-control main-input" id="login" [(ngModel)]="code_promo">
              </div>
              <div class="col-12 col-md-4">
                <button class="" mat-stroked-button (click)="checkCodePromo()"
                  [ngClass]="code_promo ? 'activebtn' : 'disablebtn' " [disabled]="!code_promo"
                  color="primary">{{ 'SEARCH.STATIONCONFIRMEVERIFIER' | translate }}</button>
              </div>
            </div>
            <div class="row justify-content-center" *ngIf="response_code_promo">
              <p class="mr-2">{{response_code_promo.message}}</p>
              <p class="ml-4" *ngIf="response_code_promo.message && response_code_promo.code !== 1 ">{{ 'SEARCH.STATIONCONFIRMENEWPRICE' | translate }} : {{response_code_promo?.new_price}} €
              </p>
            </div>
          </div>


          <div class="col-12" *ngIf="IsWait === false">
            <div class="row">

              <label class="col-12 col-md-7 blocv">
                <mat-checkbox [ngStyle]="checked?{'color': 'blue'}  : {'color': 'red'}" class="mr-1"
                  [(ngModel)]="checked"></mat-checkbox>
                <a style="font-size: 12px !important;" class="col-12" [ngStyle]="checked?{'color': 'blue'}  : {'color': 'red'}" target="target"
                  routerLink="/cgu">{{ stationDetail?.type === 1 ? ('SEARCH.STATIONCONFIRMECGUPERMIS' | translate) : ('SEARCH.STATIONCONFIRMECGU' | translate) }}</a>
              </label>




              <div class="col-12 col-md-5">
                <div class="row justify-content-end">
                  <div class="col-7 col-lg-4">
                    <label  class="bold">
                      <mat-icon aria-hidden="false" aria-label="Prix">payment</mat-icon>
                      {{ 'SEARCH.STATIONCONFIRMEPRIXTOTAL' | translate }}: {{response_code_promo_price !== undefined ? response_code_promo_price : stationPrice.price }}€
                    </label>
                  </div>
                  <div *ngIf="stationDetail?.type === 1" class="col-5 col-lg-4">
                    <label  class="bold">
                      <!-- <mat-icon aria-hidden="false" aria-label="Prix">payment</mat-icon> -->
                     + {{ stationPrice.extra.KmTTC }} €/km
                    </label>
                  </div>
                  <div *ngIf="stationDetail?.type === 0 || stationDetail?.type === 7" class="col-12 col-md-4">
                    <label  class="bold">
                      <!-- <mat-icon aria-hidden="false" aria-label="Prix">payment</mat-icon> -->
                     + {{ stationPrice.extra.KwhTTC }} €/kWh
                    </label>
                  </div>
                </div>
              </div>



            </div>

            <div class="row mt-3 mt-md-1">

              <label *ngIf="stationDetail?.type === 1 || stationDetail?.type === 10 || stationDetail?.type === 12" class="col-12 col-md-7 geoloc">
                <mat-checkbox [ngStyle]="checkedgeolocalistion?{'color': 'blue'}  : {'color': 'red'}" class="mr-1"
                  [(ngModel)]="checkedgeolocalistion"></mat-checkbox>
                <a style="font-size: 12px !important;" class="col-12" [ngStyle]="checkedgeolocalistion?{'color': 'blue'}  : {'color': 'red'}" target="target"
                 >{{'SEARCH.STATIONCONFIRMEGEOLOCALISATION' | translate }}</a>
              </label>

            </div>


          </div>


          <div class="col-12" *ngIf="IsWait === false && (stationDetail?.type === 1 || stationDetail?.type === 10 || stationDetail?.type === 12)">
            <div class="row justify-content-end my-3 mr-3">
              <div *ngIf="canReserved; then canReserved else cantReserved"></div>
              <ng-template #canReserved><button class="col- 12 col-md-3" mat-stroked-button (click)="confirmBook()"
                  [ngClass]="checked && checkedgeolocalistion ? 'activebtn' : 'disablebtn' " color="primary"
                  [disabled]="!checked || !checkedgeolocalistion">{{ 'SEARCH.STATIONCONFIRMEBOUTONCONFIRMER' | translate }}</button>
              </ng-template>
              <ng-template #cantReserved><button class="col-3" mat-stroked-button disabled
                  color="primary">{{ 'SEARCH.STATIONCONFIRMEBOUTONRESERVER' | translate }}</button>
              </ng-template>
            </div>

          </div>



          <div class="col-12" *ngIf="IsWait === false && (stationDetail?.type === 0 || stationDetail?.type === 7)">
            <div class="row justify-content-end my-3 mr-3">
              <div *ngIf="canReserved; then canReserved else cantReserved"></div>
              <ng-template #canReserved><button class="col- 12 col-md-3" mat-stroked-button (click)="confirmBook()"
                  [ngClass]="checked ? 'activebtn' : 'disablebtn' " color="primary"
                  [disabled]="!checked">{{ 'SEARCH.STATIONCONFIRMEBOUTONCONFIRMER' | translate }}</button>
              </ng-template>
              <ng-template #cantReserved><button class="col-3" mat-stroked-button disabled
                  color="primary">{{ 'SEARCH.STATIONCONFIRMEBOUTONRESERVER' | translate }}</button>
              </ng-template>
            </div>

          </div>


          <!-- <div class="col-6">
            <div class="row ">
              <div class="col-12">
                <div class="row ">
                  <mat-slide-toggle class="col-12" disabled>
                    Je partage mon trajet
                  </mat-slide-toggle>
                </div>
                <div class="col-12">
                  <mat-icon aria-hidden="false" aria-label="info">info</mat-icon>
                  <label>Ouvrez votre trajet au covoiturage pour reduire le prix total</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="row justify-content-end">
              <div class="col-4">
                <mat-icon aria-hidden="false" aria-label="Prix">payment</mat-icon>
                <label>Prix total: {{stationPrice.price}}€</label>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-12">
            <div class="row  justify-content-end">
              <mat-checkbox class="col-12">Valider les conditions générales d'utilisation ...</mat-checkbox>

              

            </div>
          </div> -->
        </div>
      </div>
    </div>
  </ng-template>

</ng-template>
<ng-template #loading>
  <div class="row justify-content-center">
    <div class="col-4">

      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</ng-template>